/**
 * Computes a zero-padded 4-digit bucket label for a photo count.
 *
 * Used for grouping Datadog RUM events by `n_photos` ranges with consistent
 * lexicographic sort (so dashboards stable-order by string).
 *
 * Examples (bucketSize=50): 1 → "0001-0050", 75 → "0051-0100", 200 → "0151-0200".
 */
export const getNPhotosBucket = (n: number, bucketSize = 50): string => {
  const k = Math.ceil(Math.max(1, n) / bucketSize);
  const lo = (k - 1) * bucketSize + 1;
  const hi = k * bucketSize;
  const pad = (x: number) => String(x).padStart(4, '0');
  return `${pad(lo)}-${pad(hi)}`;
};
